import { useEffect, useState } from 'react';
import { systemSoundsService } from '../../common/services/systemSoundsService';

export function useSystemSounds() {
  const [, setTick] = useState(0);

  useEffect(() => {
    const update = () => setTick((t) => t + 1);

    systemSoundsService.subscribe(update);

    return () => {
      systemSoundsService.unsubscribe(update);
    };
  }, []);

  return {
    play: systemSoundsService.play.bind(systemSoundsService),
    loading: systemSoundsService.loading,
    error: systemSoundsService.error,
    mute: systemSoundsService.mute.bind(systemSoundsService),
    isMuted: systemSoundsService.isMuted,
  };
}